export enum ContentStyle {
  FLOATING = 0,
  BOXED = 1,
}
